// requests
export const REQUEST = 'requests/REQUEST';
export const REQUEST_SUCCESS = 'requests/REQUEST_SUCCESS';
export const REQUEST_FAILURE = 'requests/REQUEST_FAILURE';
export const CLEAR_SPECIFIC_REQUEST = 'requests/CLEAR_SPECIFIC_REQUEST';
export const CLEAR_REQUEST = 'requests/CLEAR_REQUEST';
